<template>
    <form @submit.prevent="updateProfileInformation">
        <FormSection>
            <template #title>
                Profile Information
            </template>
            <template #description>
                Update your account's name and email address.
            </template>

            <div class="row">
                <div class="col-full lg:col-1/2">
                    <FormGroup
                        name="firstname"
                        label="First Name">
                        <Input
                            v-model="form.firstname"
                            name="firstname"
                            placeholder="Please enter the firstname..."
                            autofocus/>
                    </FormGroup>
                </div>
                <div class="col-full lg:col-1/2">
                    <FormGroup
                        name="lastname"
                        label="Last Name">
                        <Input
                            v-model="form.lastname"
                            name="lastname"
                            placeholder="Please enter the lastname..."/>
                    </FormGroup>
                </div>
            </div>

            <FormGroup
                name="email"
                label="Email">
                <Input
                    v-model="form.email"
                    type="email"
                    placeholder="Please enter your email..."
                    required
                    autocomplete="new-password"/>
            </FormGroup>

            <FormGroup
                name="phone"
                label="Phone">
                <Input
                    v-model="form.phone"
                    name="phone"
                    placeholder="Please enter a phone number..."/>
            </FormGroup>

            <FormGroup
                name="profile_image_id"
                label="Profile Image">
                <File
                    v-model="form.profile_image_id"
                    :file="user.profile_image || {}"
                    :image="true"
                    accept="image/jpeg,image/png"/>
            </FormGroup>

            <template #footer>
                <ActionMessage
                    :on="form.recentlySuccessful"
                    class="mr-3">
                    Saved.
                </ActionMessage>
                <SubmitButton
                    :submitting="form.processing"
                    :disabled="form.errors.any()">
                    Update
                </SubmitButton>
            </template>
        </FormSection>
    </form>
</template>

<script>

import FormSection from "@/Components/Form/FormSection";
import FormGroup from "@/Components/Form/FormGroup";
import Input from "@/Components/Form/Input";
import ActionMessage from "@/Components/ActionMessage";
import SubmitButton from "@/Components/Form/SubmitButton";
import File from "@/Components/Form/File";

export default {

    props: {
        user: Object
    },

    data() {
        return {
            form: this.$form({
                firstname: this.user.firstname,
                lastname: this.user.lastname,
                email: this.user.email,
                phone: this.user.phone,
                profile_image_id: this.user.profile_image_id,
            }, {
                resetOnSuccess: false,
            }),
        }
    },

    provide() {
        return {
            form: this.form,
        }
    },

    components: {
        FormSection,
        FormGroup,
        Input,
        File,
        ActionMessage,
        SubmitButton
    },

    methods: {
        updateProfileInformation() {
            this.form.put(route('user-profile-information.update'))
            .then(() => {
                this.$store.dispatch('fetchUser');
                this.$notify.success('Profile information updated');
            })
            .catch();
        },
    }
}
</script>
